import { Icon, IconsEnum } from 'components/Icons';
import { isCarrelloTypeIppica, isCarrelloTypeVirtual } from 'features/carrello/utils';
import { selectCarrelloScommesseCount, selectTipo } from 'features/carrello/carrelloSelectors';
import { selectIsActiveIppica, selectIsActiveVirtual } from 'features/configuration/selectors';
import { useAppDispatch, useTypedSelector } from 'lib/centralStore';

import { MovimentiTipoScommessaEnum } from 'types/swagger';
import styles from './CarrelloContentDropdown.module.scss';
import { tipoCarrelloSelected } from 'features/carrello/carrelloSlice';
import { useState } from 'react';
import classNames from 'classnames';

export const CarrelloContentDropdown = ({ className, showCounter }: { className?: string; showCounter?: boolean }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  // TODO settare il selected value di default
  const dispatch = useAppDispatch();
  const tipo = useTypedSelector(selectTipo);
  const carrelloScommesseCountList = useTypedSelector(selectCarrelloScommesseCount);
  const scommesseCountSelected = carrelloScommesseCountList.find((c) => c.label === tipo);
  const isActiveVirtual = useTypedSelector(selectIsActiveVirtual);
  const isActiveIppica = useTypedSelector(selectIsActiveIppica);
  const handleClick = (value: MovimentiTipoScommessaEnum) => {
    setIsOpen(false);
    dispatch(tipoCarrelloSelected(value));
  };

  return (
    <div className={classNames(styles.container, className, { [styles.open]: isOpen })}>
      <button type="button" className={styles.button} onClick={() => setIsOpen(true)}>
        <p className={styles.paragraph}>
          {tipo}
          {showCounter && scommesseCountSelected && (
            <span className={styles.number}>{`(${scommesseCountSelected.count})`}</span>
          )}
        </p>
        <Icon iconId={IconsEnum.CHEVRON_DOWN} className={styles.icon} color="var(--color-on-bg-primary)" />
      </button>

      <div className={`${styles.wrapper} ${isOpen && styles.visible}`}>
        <button type="button" className={styles.firstButton} onClick={() => setIsOpen(false)}>
          Area
          <Icon iconId={IconsEnum.CHEVRON_UP} className={styles.icon} color="var(--color-on-bg-primary)" />
        </button>
        {carrelloScommesseCountList.map((scommesseCount) => {
          const { label, count } = scommesseCount;

          if ((isCarrelloTypeVirtual(label) && !isActiveVirtual) || (isCarrelloTypeIppica(label) && !isActiveIppica)) {
            return null;
          }
          return (
            <button
              type="button"
              className={`${styles.button} ${styles.item}`}
              onClick={() => handleClick(label)}
              key={label + '_CarrelloContentDropdown'}
            >
              <div className={styles.paragraph}>
                {label}
                {showCounter && <span className={styles.number}>{`(${count})`}</span>}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};
